<template>
  <div class="app-main-content">
    <div class="details-view">
      <cargo-left-right-resize
        :show-left="showSidebar"
        :left-style="{display:'flex',flex:'none',minWidth:'220px'}"
        :right-style="{display:'flex','overflow': 'hidden'}"
        style="min-height:100%"
      >
        <template slot="left">
          <div class="section" style="flex: 1">
            <el-scrollbar style="flex: 1;">
              <el-menu :default-active="activeIndex" style="flex: 1" class="report-menu">
                <template v-for="report in reports">
                  <report-sub-item :key="report.id" :item="report" @click="onClick" />
                </template>
              </el-menu>
            </el-scrollbar>
          </div>
        </template>
        <template slot="right">
          <div class="section" style="position:relative;flex: 1">
            <report-item-detail
              v-if="Boolean(selectedReport)"
              :key="selectedReport.reportId"
              :report-id="selectedReport.reportId"
              :descriptor-registry="descriptorRegistry"
            />
            <div
              v-else
              style="position: absolute;top:50%;left: 50%; text-align:center;transform: translate(-50%,-50%)"
            >
              <img width="194" height="200" src="/static/report.png">
            </div>
          </div>
        </template>
      </cargo-left-right-resize>
    </div>

    <!--报表弹出窗-->
    <el-dialog
      v-if="reportDialog.visible"
      v-el-drag-dialog
      :visible.sync="reportDialog.visible"
      :title="$t('CargoMsg.Cargo_ExcelTemplateExport')"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form :inline="true" label-width="100px" style="flex-grow: 1">
        <condition-form-item v-for="(item,index) in reportDialog.params" :key="index" :item="item" />
      </el-form>
      <span slot="footer">
        <el-button @click="runReport">{{ $t('CargoMsg.Cargo_Run') }}</el-button>
        <el-button @click="reportDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!-- 用于打开新页面，并以post方式提交 -->
    <form ref="form" :action="fileUrl" target="_blank" method="post" style="display:none">
      <input v-for="item in fileFormEntries" :key="item[0]" :name="item[0]" :value="item[1]">
    </form>
  </div>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import ReportSubItem from '@/views/cargo/v0/Analysis/components/ReportSubItem'
import ReportItemDetail from '@/views/cargo/v0/Analysis/components/ReportItemDetail'
import { cacheName, cache } from '@/utils/cacheManager'
import { DescriptorRegistry } from '@/class/model/DescriptorRegistry'
import ConditionFormItem from '@/views/cargo/v0/Analysis/components/ConditionFormItem'
import * as dw from '@/api/dw'
import X2js from 'x2js'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import moment from 'moment'

export default {
  name: 'AnalysisDetails',
  components: { CargoLeftRightResize, ReportSubItem, ReportItemDetail, ConditionFormItem },
  data() {
    return {
      descriptorRegistry: null,
      reports: [],
      selectedReport: null,
      activeIndex: '',
      reportDialog: {
        visible: false,
        params: [],
        reportId: '',
        reportName: ''
      },
      fileUrl: '',
      fileFormEntries: []
    }
  },
  computed: {
    showSidebar() {
      return !this.$route.query.openNew || !this.$route.query.key
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  async created() {
    if (!cache.config) {
      await cache.load(cacheName.CONFIG)
    }
    dw.repositoryServlet({ operate: 'findSchema' }).then(res => {
      const { factTables, dimensionTables, descriptorMap } = res.content
      this.descriptorRegistry = new DescriptorRegistry(factTables, dimensionTables, descriptorMap)
    })
    const analysisList = this.$store.state.permission.analysisList
    const analysis = analysisList.find(p => p.id === this.$route.query.id)
    if (analysis) {
      this.reports = analysis.exploreList
    }
    const query = this.$route.query
    if (query.openNew && query.key) {
      this.selectedReport = this.getReport(this.reports, query.key)
      if (this.selectedReport) {
        this.activeIndex = this.selectedReport.id
      }
    }
  },
  activated() {
    if (this.selectedReport) {
      this.activeIndex = this.selectedReport.id
    }
  },
  deactivated() {
    this.activeIndex = ''
  },
  methods: {
    getReport(reports, reportId) {
      for (const item of reports) {
        if (item.leaf) {
          if (item.reportId === reportId) {
            return item
          }
        } else {
          const result = this.getReport(item.exploreList, reportId)
          if (result) {
            return result
          }
        }
      }
      return null
    },
    async onClick(data) {
      const query = this.$route.query
      const type = data.type
      // dw报表分为两类，一类是需要界面显示，有查询界面的（type!=2）。另一类是直接弹出弹框，导出Excel(type=2)
      if (type === '2') {
        this.reportDialog.params = []
        this.reportDialog.reportId = data.reportId || ''
        this.reportDialog.reportName = data.name
        await dw.repositoryServlet({ 'reportId': data.reportId, 'type': type, operate: 'findReport' }).then(res => {
          if (res.content) {
            const obj = new X2js().xml2js(res.content)
            if (obj && obj.exportTemplate && obj.exportTemplate.param) {
              const params = this.getReportParam(obj.exportTemplate.param)
              if (params.length > 0) {
                this.reportDialog.params = params
                this.reportDialog.visible = true
              }
            }
          }
        })
      } else {
        const rawLocation = { name: 'AnalysisDetails', query: { id: query.id, openNew: true, key: data.reportId, title: this.isZh ? data.name : (data.englishName || data.name) }}
        this.$router.push(rawLocation)
      }
    },
    getReportParam(params) {
      const result = []
      if (!params) {
        return result
      }
      if (!(params instanceof Array)) {
        params = [params]
      }
      for (const param of params) {
        if (param) {
          if (param._defaultValue && param._defaultValue.charAt(0) === '{' && param._defaultValue.charAt(param._defaultValue.length - 1) === '}') {
            continue
          }
          const obj = {
            code: param._code,
            dataType: this.convertDataType(param._dataType),
            displayName: param._name,
            reportName: param._reportName,
            isRange: false,
            isMore: false,
            value: param._defaultValue
          }
          if (!param._defaultValue && obj.dataType === 5) {
            obj.value = moment().format('YYYY-MM-DD')
          }
          if (param.hasOwnProperty('isMore')) {
            obj.isMore = param.isMore === 'true'
          }
          if (param.placeHolder && param.placeHolder.hasOwnProperty('isRange')) {
            obj.isRange = param.placeHolder.isRange === 'true'
          }
          result.push(obj)
        }
      }
      return result
    },
    convertDataType(dataType) {
      switch (dataType) {
        case 'string':
          return 1
        case 'integer':
          return 2
        case 'double':
          return 3
        case 'boolean':
          return 4
        case 'date':
          return 5
        default:
          break
      }
      return 0
    },
    runReport() {
      this.reportDialog.visible = false
      const officeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', this.$store.getters.currentOfficeId, 'englishName')
      const userInfo = this.$store.getters.userInfo
      const params = {
        operate: 'run',
        reportId: this.reportDialog.reportId,
        officeCode: officeCode,
        tenantId: userInfo.tenantId,
        departmentCode: this.$store.getters.currentDept.englishName,
        sessionId: userInfo.sessionId,
        check: true
      }
      for (const item of this.reportDialog.params) {
        params[item.code] = encodeURIComponent(item.value)
      }
      const loading = getLoading4Cxt(this)
      dw.runtimeServlet(params).then(res => {
        if (res.ok) {
          this.$confirm(this.$t('CargoMsg.Cargo_ExportExcelTemplate'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'success'
          }).then(() => {
            params.language = this.isZh ? 'zh_CN' : 'en_US'
            params.filename = encodeURIComponent(this.reportDialog.reportName + '_' + moment(new Date()).format('YYYYMMDDHHNNSSQQQ') + '.xls')
            params.check = false
            this.fileUrl = dw.getRuntimeServletUrl()
            this.fileFormEntries = Object.entries(params)
            this.$nextTick(() => {
              this.$refs.form.submit()
            })
          }).catch(() => {
          })
        }
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  .report-menu::v-deep.el-menu {
    .el-submenu {
      & > .el-submenu__title {
        padding-left: 20px !important;
      }
      .el-menu-item {
        background-color: #fafafa;
        &:hover,
        &.is-active {
          background-color: #eaf2fb;
        }
      }
    }
    .el-submenu__icon-arrow {
      display: inline !important;
    }
  }
}
</style>
